import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ownerApi } from "./ownerApi";
import { Shield, ArrowRight } from "lucide-react";

export default function OwnerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [requires2fa, setRequires2fa] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await ownerApi.post("/auth/login", { email, password, totp_code: totp || undefined });
      if (data.requires_2fa) { setRequires2fa(true); setLoading(false); return; }
      localStorage.setItem("buddy_owner_token", data.access_token);
      localStorage.setItem("buddy_owner_role", data.admin.role);
      navigate("/owner/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0A0F14", color: "#E8E4DC" }}>
      <div className="w-full max-w-md p-8 rounded-2xl" style={{ background: "#11181F", border: "1px solid #1F2A33" }} data-testid="owner-login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "#006039" }}><Shield size={20} color="white" /></div>
          <div>
            <h1 className="font-display text-xl font-bold">Buddy Owner Panel</h1>
            <p className="text-xs" style={{ color: "#7A7A72" }}>Internal — Auth required</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" placeholder="owner@buddy.app" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full px-3 py-2.5 rounded-lg text-sm outline-none" style={{ background: "#0A0F14", border: "1px solid #1F2A33", color: "#E8E4DC" }} data-testid="owner-email" />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full px-3 py-2.5 rounded-lg text-sm outline-none" style={{ background: "#0A0F14", border: "1px solid #1F2A33", color: "#E8E4DC" }} data-testid="owner-password" />
          {requires2fa && (
            <input type="text" placeholder="6-digit 2FA code" value={totp} onChange={(e) => setTotp(e.target.value)} required maxLength={6}
              className="w-full px-3 py-2.5 rounded-lg text-sm outline-none tracking-widest text-center" style={{ background: "#0A0F14", border: "1px solid #C9A96E", color: "#E8E4DC" }} data-testid="owner-2fa" />
          )}
          {error && <div className="text-xs px-3 py-2 rounded-lg" style={{ background: "#3a1a1f", color: "#ff6b80" }}>{error}</div>}
          <button type="submit" disabled={loading} className="w-full py-2.5 rounded-lg text-sm font-medium flex items-center justify-center gap-2 transition" style={{ background: "#006039", color: "white", opacity: loading ? 0.6 : 1 }} data-testid="owner-login-submit">
            {loading ? "Signing in…" : <>Sign In <ArrowRight size={14} /></>}
          </button>
        </form>
        <p className="text-[10px] mt-6" style={{ color: "#4A5560" }}>Cookies are httpOnly · 2FA recommended · All actions audit-logged.</p>
      </div>
    </div>
  );
}
